import { IChatMessage } from '@/types';
import { getUrl } from '@/utils/api';

function useChatHistory(id: string) {
  const query = getUrl(`v1/prompts/${id}/history`);
  return {
    ...query,
    data: query.data as IChatMessage[],
  };
}

export default useChatHistory;
